
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"23","height":"22","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M18.833 3.667H4.166A1.82 1.82 0 002.342 5.5l-.009 11c0 1.017.816 1.833 1.833 1.833h14.667a1.827 1.827 0 001.833-1.833v-11a1.827 1.827 0 00-1.833-1.833zm0 12.833H4.166V11h14.667v5.5zM4.166 7.333h14.667V5.5H4.166v1.833z","fill":"#C4C4C4"}})])
          )
        }
      }
    